import borMarkup from '@/assets/BOR.svg?raw'
import driverMarkup from '@/assets/driver.svg?raw'
import lossRunMarkup from '@/assets/loss-run.svg?raw'
import trailerMarkup from '@/assets/trailer.svg?raw'
import truckMarkup from '@/assets/truck.svg?raw'
import { cn } from '@/lib/utils'

export enum IllustrationName {
  DRIVER = 'driver',
  TRUCK = 'truck',
  TRAILER = 'trailer',
  BOR = 'bor',
  LOSS_RUN = 'loss-run',
}

const MARKUP: Record<IllustrationName, string> = {
  [IllustrationName.DRIVER]: driverMarkup,
  [IllustrationName.TRUCK]: truckMarkup,
  [IllustrationName.TRAILER]: trailerMarkup,
  [IllustrationName.BOR]: borMarkup,
  [IllustrationName.LOSS_RUN]: lossRunMarkup,
}

/**
 * The application's line-art illustrations, shown bare — no circle, no fill behind them.
 *
 * Inlines the markup rather than pointing an <img> at the file: an <img> rasterizes into its
 * own buffer before compositing, which visibly roughens 400x400 artwork shrunk to 56px, while
 * inline markup rasterizes with the page at full device resolution. geometricPrecision then
 * opts out of the renderer's speed-over-accuracy default and inherits to every child shape.
 */
export function Illustration({
  name,
  className,
  muted,
}: {
  name: IllustrationName
  className?: string
  /** De-emphasises the artwork for empty states. */
  muted?: boolean
}) {
  return (
    <span
      aria-hidden
      className={cn(
        'block size-14 shrink-0 [&>svg]:size-full [&>svg]:[shape-rendering:geometricPrecision]',
        // The artwork hardcodes fill="black", so lightening it means overriding the fill on the
        // shapes themselves; the root <svg fill="none"> is left alone.
        muted && '[&_svg_*]:fill-ink-400',
        className
      )}
      dangerouslySetInnerHTML={{ __html: MARKUP[name] }}
    />
  )
}
